<template>
    <div>
        <v-app-bar app
                   clipped-right
                   color="primary darken-3"
                   dark>
            <v-app-bar-nav-icon @click.stop="menu_drawer = !menu_drawer"></v-app-bar-nav-icon>
            <!--<v-menu transition="scale-transition" v-if="true"
                    offset-y="true" min-width="250px">
                <template v-slot:activator="{ on: menu }">
                    <template v-if="is_disp_order_err_badge">
                        <v-badge color="green"
                                 bottom overlap
                                 :content="order_err_cnt">
                            <v-app-bar-nav-icon v-on="{ ...menu }"></v-app-bar-nav-icon>
                        </v-badge>
                    </template>
                    <template v-if="!is_disp_order_err_badge">
                        <v-app-bar-nav-icon v-on="{ ...menu }"></v-app-bar-nav-icon>
                    </template>
                </template>
                <v-card style="max-height: 800px; overflow-y: auto;">
                    <v-list>
                        <v-list-item v-on:click="changePage('/Top/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-home</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Top</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="Permission == 2 || Permission == 4"
                                     v-on:click="changePage('/api/ChoaiMaintenancePrefectures/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>帳合マスタ（都道府県）</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="Permission == 2 || Permission == 4"
                                     v-on:click="changePage('/api/ChoaiMaintenanceStoreGroup/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>帳合マスタ（{{ kaisya_nm }}）</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="changePage('/api/ChoaiMaintenance/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>帳合マスタ（店舗）</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="changePage('/api/OrderSlipHistory/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-cart-variant</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>発注履歴</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="changePage('/api/DeliverySlipHistory/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-dolly</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>納品履歴</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="changePage('/api/OrderSlipError/Index')">

                            <v-list-item-icon>
                                <v-icon>mdi-cart-remove</v-icon>
                                <v-badge :content="order_err_cnt"
                                         v-if="is_disp_order_err_badge"
                                         color="primary">

                                </v-badge>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>発注エラー</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="changePage('/api/Product/Index')">

                            <v-list-item-icon>
                                <v-icon>mdi-flask-outline</v-icon>
                                <v-badge :content="order_err_cnt"
                                         v-if="is_disp_order_err_badge"
                                         color="primary">

                                </v-badge>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>商品マスタ照会</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-on:click="changePage('/api/Manufacturer/Index')">

                            <v-list-item-icon>
                                <v-icon>mdi-factory</v-icon>
                                <v-badge :content="order_err_cnt"
                                         v-if="is_disp_order_err_badge"
                                         color="primary">

                                </v-badge>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>メーカーマスタ照会</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="Permission == 2 || Permission == 4"
                                     v-on:click="changePage('/api/StoreMaster/Index')">
                            <v-list-item-icon>
                                <v-icon>store</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>店舗マスタ照会</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="Permission == 2 || Permission == 4"
                                     v-on:click="changePage('/api/StoreGroupMaster/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-home-group</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>店舗グループマスタ</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="Permission != 1"
                                     v-on:click="changePage('/api/InvoiceOutput/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-export</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>お振込み依頼書・請求書兼納品書出力</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="Permission == 4"
                                     v-on:click="changePage('/store/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-store-edit</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>店舗マスタ</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="Permission == 4 || Permission==2"
                                     v-on:click="changePage('/operationlog/Index')">
                            <v-list-item-icon>
                                <v-icon>mdi-monitor-cellphone</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>アプリケーション操作ログ</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item v-on:click="changePage('/Login/Logout')">
                            <v-list-item-icon>
                                <v-icon>mdi-logout</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>ログアウト</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>-->

            <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="false"></v-app-bar-nav-icon>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <space>{{ LoginName }}</space>
            <space v-if="Permission == 2">（管理者）</space>
            <v-app-bar-nav-icon @click.stop="drawerRight = !drawerRight" v-if="false"></v-app-bar-nav-icon>
        </v-app-bar>

        <v-navigation-drawer v-model="menu_drawer" fixed
                             style="padding-top:80px; z-index: 3;"
                             width="320">
            <v-list dense expand>
                <v-list-item v-on:click="changePage('/Top/Index')">
                    <v-list-item-icon>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Top</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <template v-for="menu_1st in menu_list">
                    <template v-if="menu_1st.children.length == 0">
                        <v-list-item :href="getPage(menu_1st.func_id)"
                                     :key="menu_1st.menu_no">
                            <v-list-item-icon>
                                <v-icon>{{ menu_1st.menu_icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ menu_1st.menu_title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <template v-else>
                        <v-list-group :key="menu_1st.menu_no">
                            <template v-slot:activator>
                                <v-list-item-icon>
                                    <v-icon>{{ menu_1st.menu_icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content @click="menu_1st.is_open = !menu_1st.is_open">
                                    <v-list-item-title>{{ menu_1st.menu_title }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <template v-for="(menu_2nd, idx2) in menu_1st.children">
                                <template v-if="menu_2nd.children.length == 0">
                                    <v-list-item :href="getPage(menu_2nd.func_id)"
                                                 :key="menu_2nd.menu_no">
                                        <v-list-item-content>
                                            <v-list-item-title class="ml-12">{{ idx2 + 1 }}.{{ menu_2nd.menu_title }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                                <template v-else>
                                    <v-list-group sub-group :value="menu_2nd.is_open" :key="menu_2nd.menu_no">
                                        <template v-slot:activator>
                                            <v-list-item-title>{{ idx2 + 1 }}.{{ menu_2nd.menu_title }}</v-list-item-title>
                                        </template>
                                        <v-list-item :href="getPage(menu_3rd.func_id)"
                                                     v-for="menu_3rd in menu_2nd.children"
                                                     :key="menu_3rd.menu_no">
                                            <v-list-item-title class="ml-12">{{ menu_3rd.menu_title }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list-group>
                                </template>
                            </template>
                        </v-list-group>
                    </template>
                </template>

                <!--<v-list-group no-action v-for="menu_1st in menu_list" :key="menu_1st.menu_no">
                    <template v-slot:activator>
                        <v-list-item-icon>
                            <v-icon>{{ menu_1st.menu_icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content @click="menu_1st.is_open = !menu_1st.is_open">
                            <v-list-item-title>{{ menu_1st.menu_title }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <template v-for="(menu_2nd, idx2) in menu_1st.children">
                        <template v-if="menu_2nd.children.length != 0">
                            <v-list-group sub-group :value="menu_2nd.is_open" :key="menu_2nd.menu_no">
                                <template v-slot:activator>
                                    <v-list-item-title>{{ idx2 + 1 }}.{{ menu_2nd.menu_title }}</v-list-item-title>
                                </template>
                                <v-list-item :href="getPage(menu_3rd.func_id)"
                                             v-for="menu_3rd in menu_2nd.children"
                                             :key="menu_3rd.menu_no">
                                    <v-list-item-title>{{ menu_3rd.menu_title }}</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                        </template>
                        <template v-else>
                            <v-list-item :href="getPage(menu_3rd.func_id)"
                                         :key="menu_2nd.menu_no">
                                <v-list-item-content>
                                    <v-list-item-title>{{ menu_2nd.menu_title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </template>
                </v-list-group>-->
                <v-divider></v-divider>
                <v-list-item v-on:click="changePage('/Login/Logout')">
                    <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>ログアウト</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-navigation-drawer v-model="drawerRight" v-if="false"
                             app
                             clipped
                             right>
            <v-list dense>
                <v-list-item @click.stop="right = !right">
                    <v-list-item-content>
                        <v-list-item-title>登録</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item @click.stop="right = !right">
                   
                    <v-list-item-content>
                        <v-list-item-title>動作テスト</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-navigation-drawer v-model="drawer" v-if="false"
                             app>
            <v-list dense>
                <v-list-item v-on:click="changePage('choai')">
                    <!--<v-list-item-action>
                    <v-icon>exit_to_app</v-icon>
                </v-list-item-action>-->
                    <v-list-item-content>
                        <v-list-item-title>帳合マスタ</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-on:click="changePage('store')">
                    <v-list-item-content>
                        <v-list-item-title>店舗マスタ</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>


        <v-navigation-drawer v-model="left"
                             fixed
                             temporary>

        </v-navigation-drawer>
        <v-navigation-drawer v-model="right"
                             fixed
                             right
                             temporary></v-navigation-drawer>

        <div v-if="color_check">
            <slot></slot>
        </div>
        <v-footer app
                  color="primary darken-3"
                  class="white--text">
            <span>{{ sys_nm }}</span>
            <span style="margin: 0px 20px">Ver - {{ AppVersion }}</span>
            <v-spacer></v-spacer>
            <template v-if="is_initdata_loading">
                <v-row>

                    <v-col>
                       
                    </v-col>
                    <v-col>
                        <v-progress-linear color="amber"
                                           indeterminate
                                           rounded
                                           height="6"></v-progress-linear>
                        マスタ更新中
                    </v-col>
                </v-row>
                
            </template>
            <span>&copy; {{ currentYear }}</span>
        </v-footer>
    </div>
</template>

<script>
    
    export default {
        props: ['title', 'url', 'is_initdata_loading' ],

        data: () => ({
            drawer: null,
            drawerRight: false,
            right: false,
            left: false,
            order_err_cnt: 55,
            AppVersion: g_version,
            StoreCode: g_login_code,
            LoginName: g_login_name,
            Permission: g_permission,
            searchCategory: {
                category_key: '',
                category_cd: '',
            },
            sys_nm: '',
            kaisya_nm: '',
            items: [],
            sys_color: g_sys_color,
            color_check: false,
            currentYear: new Date().getFullYear(),
            menu_list: [],
            menu_drawer: false,
        }),
        mounted: function () {
            this.onChangeColor();
            this.$nextTick(function () {
                // ビュー全体がレンダリングされた後にのみ実行されるコード
                this.onGetOrderErrCnt();
                this.onGetCodeCategory();
                this.onGetCodeCategory_Kaisya();
                this.onGetMenuList();
            })
        },
        computed: {
            is_disp_order_err_badge: function () {
                if (this.Permission == '2') {
                    return false;
                }

                if (this.order_err_cnt == 0) {
                    return false;
                }
                return false;
            }
        },
        methods: {
            changePage: function (page) {

                if (this.url == page) {
                    console.log('遷移しない');
                    return;
                }

                window.location.href = page;
            },
            async onGetOrderErrCnt() {
                try {
                    if (this.Permission == '2') {
                        return;
                    }

                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.StoreCode));
                    let res = await this.axios_post('/api/CommonComponents/GetOrderErrCnt', params);
                    if (res.data.status !== "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }
                    this.order_err_cnt = res.data.order_err_cnt;
                } catch (e) {
                    console.log(e);
                }
            },
            async onGetCodeCategory() {
                try {
                    var params = new URLSearchParams();
                    this.searchCategory.category_key = "LOGIN_SYSTEM_NM";
                    this.searchCategory.category_cd = "";
                    this.items = [];
                    params.append('param', JSON.stringify(this.searchCategory));
                    let res = await this.axios_post('/CodeCategory/Get', params);
                    this.sys_nm = res.data.items[0].category_nm;
                } catch (e) {
                    console.log(e);
                }
            },
            async onGetCodeCategory_Kaisya() {
                try {
                    var params = new URLSearchParams();
                    this.searchCategory.category_key = "JIGYOGAISYA_NM";
                    this.searchCategory.category_cd = "";
                    this.items = [];
                    params.append('param', JSON.stringify(this.searchCategory));
                    let res = await this.axios_post('/CodeCategory/Get', params);
                    this.kaisya_nm = res.data.items[0].category_nm;
                } catch (err) {
                    console.log(err);
                }
            },
            onChangeColor() {
                this.$vuetify.theme.themes.light.primary = this.sys_color;
                this.color_check = true;
            },
            async onGetMenuList() {
                try {
                    const params = new URLSearchParams();
                    params.append('param', JSON.stringify({ login_id: this.StoreCode }));

                    const res = await this.axios_post('/MyMenu/GetMenuList', params);
                    if (res.data.status !== 'OK') {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }

                    console.log(res.data.menu_list);

                    this.menu_list = res.data.menu_list;
                } catch (e) {
                    this.msg_error_dialog(e);
                }
            },
            getPage(page) {
                return `/${page}`;
            },
            test: function () {
                alert('開発中');
            }
        }
    }
</script>